export default class InteractiveCatalogPageLayer {

    constructor() {
        this.name = '';
        this.items = [];    // List of InteractiveCatalogPageItem
        this.hidden = false;
    }

}
